import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME as name, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';
import { editMutations } from './types';

const dropdownList = {
	DphSzbOzn: [],
	ProvozovnaId: [],
};

const edit = {
	CvNr: null as string | null,
	ExternalOperationTypeId: 0 as number | 0,
	DphSzbOzn: null as number | null,
	Mnozstvi: null as number | null,
	Nc: null as number | null,
	Pc: null as number | null,
	Poznamka2Dd: null as string | null,
	ProvozovnaId: null as number | null,
	Sleva: null as number | null,
	StrednaklOzn: null as number | null,
	StrednaklOznText: null as string | null,
	Text: null as string | null,
	VstupDat: null as string | null,
	VstupPracId: null as number | null,
	VstupPracIdText: null as string | null,
	VstupProvId: null as number | null,
	ZakazkaId: null as number | null,
	ZaznamId: null as number | null,
	IsGaranceOrKulance: null as boolean | null,
	VyrobekvozOzn: null as string | null,
	UpravaS2: null as boolean | null,
	NavrhPolId: null as number | null,
	Gst: null as number | null,
	PcWithGst: null as number | null,
	NcWithGst: null as number | null,
	IsChecked: null as boolean | null,
};

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList,
	edit,
	depTableNames: [],
	depTableSettings: {},
	localState: {
		SazbyDph: null as any | null,
	},
	extraActions: {},
	extraGetters: {},
	extraMutations: {
		[editMutations.CIZY_VYKONY_CV_SELECT_MAPPER](state, { data }) {
			state.edit.CvNr = data.value;
			state.edit.Text = data.text;
		},
		[editMutations.CIZY_VYKONY_NAKLADOVE_STREDISKO_SELECT_MAPPER](state, { data }) {
			state.edit.StrednaklOzn = data.value;
			state.edit.StrednaklOznText = data.text;
			if (!data.isClear) {
				state.edit.ProvozovnaId = data.provozovnaId;
			}
		},
	},
	props: {
		mode: null,
		saga2Status: null as number | null,
		polozkaText: null as string | null,
		polozkaNr: null as string | null,
		dNc: null as number | null,
		polozkaId: null as number | null,
	},
});
